import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { ProjectAttachment } from 'src/app/commons/models/project-attachment.model';
import { PAGE_SIZE_OPTIONS } from 'src/app/helpers/table.helper';
import * as ProjectAttachmentActions from 'src/app/store/actions/project-attachment.actions';
import { AppState } from 'src/app/store/reducers';
import * as ProjectAttachmentSelectors from 'src/app/store/selectors/project-attachment.selectors';

import { ProjectAttachmentFilters } from '../../../commons/models/project-attachment.model';
import { ProjectAttachmentsColumn } from '../project-attachment-list/project-attachment-list.component';


@Component({
  selector: 'app-project-attachment-selection',
  templateUrl: './project-attachment-selection.component.html',
  styleUrls: ['./project-attachment-selection.component.scss']
})
export class ProjectAttachmentSelectionComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();

  projectAttachments: ProjectAttachment[];

  @Input()
  defaultFilters: ProjectAttachmentFilters = {
    search: "",
  }

  displayedColumns: ProjectAttachmentsColumn[] = [ "name", "file", "actions"];

  pageSizeOptions = PAGE_SIZE_OPTIONS;

  total: Observable<number>;
  constructor(private store$: Store<AppState>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.store$.pipe(select(ProjectAttachmentSelectors.getProjectAttachments), takeUntil(this.unsubscribe$), map(dtos => dtos ? dtos.map(dto => new ProjectAttachment(dto)) : null)).subscribe(
      data => this.projectAttachments = data
    );
    this.total = this.store$.pipe(select(ProjectAttachmentSelectors.getTotalProjectAttachments), takeUntil(this.unsubscribe$));
    this.store$.pipe(select(ProjectAttachmentSelectors.getFilters), takeUntil(this.unsubscribe$));
    if (data) {
      this.defaultFilters = data.defaultFilters;
    }
  }

  load() {
    this.store$.dispatch(ProjectAttachmentActions.loadProjectAttachments(
      { page: 1, perPage: this.pageSizeOptions[0], filters: this.defaultFilters }));
  }

  sortChange(sort: Sort) {
    this.store$.dispatch(ProjectAttachmentActions.changeSort({ order: sort.active, direction: sort.direction }));
  }

  pageChange(pageEvent: PageEvent) {
    this.store$.dispatch(ProjectAttachmentActions.changePage({ page: pageEvent.pageIndex + 1, size: pageEvent.pageSize }))
  }

  filtersChange(filters: ProjectAttachmentFilters) {
    this.store$.dispatch(ProjectAttachmentActions.changeFilters({ filters }));
  }

  ngOnInit() {
    this.load();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  selectProjectAttachment(projectAttachment: ProjectAttachment) {
    if (projectAttachment) {
      this.store$.dispatch(ProjectAttachmentActions.projectAttachmentSelected({ projectAttachment: projectAttachment.toDTO() }));
    }
  }

  close() {
    this.store$.dispatch(ProjectAttachmentActions.closeSelectionDialog())
  }
}
